import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';
import { EventsSDKShape } from '../events';
import { IElement } from '@wix/public-editor-platform-interfaces';

export class ElementsSDKShape extends BaseSDKShape {
  async getSelection() {
    const privateAPI = await this.getPlatformPrivateAPI();
    const refs = await privateAPI.components.getSelectedComponents();

    return Promise.all<IElement[]>(
      refs.map(
        (ref: any) => privateAPI.components.getComponent(ref) as IElement,
      ),
    );
  }

  async onSelectionChange(cb: (elements: IElement[]) => void) {
    const events = new EventsSDKShape(this.getApplicationContext());
    void events.addEventListener('componentSelectionChanged', (payload) => {
      // @ts-expect-error TODO: refactor events.
      cb(payload.components);
    });
  }
}

export default new PlatformSDKShape(ElementsSDKShape)
  .withPublicMethod('onSelectionChange')
  .withPublicMethod('getSelection')
  .build();
